<template>
  <div class="card">
    <form>
      <div class="card-header">
        <h4 class="card-title">
           Change Your Password
        </h4>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>Old Password</label>
          <fg-input  type="password"
                     name="oldPassword"
                     data-vv-as="Old Password"
                     v-validate="modelValidations.oldPassword"
                     v-model="model.oldPassword"
                     :error="getError('oldPassword')">
          </fg-input>
        </div>
        <div class="form-group">
          <label>New Password</label>
          <fg-input  type="password"
                     name="newPassword"
                     ref="newPassword"
                     data-vv-as="New Password"
                     v-validate="modelValidations.newPassword"
                     v-model="model.newPassword"
                     :error="getError('newPassword')">
          </fg-input>
        </div>
        <div class="form-group">
          <label>Confirm New Password</label>
          <fg-input  type="password"
                     name="confirmPassword"
                     data-vv-as="New Password"
                     v-validate="modelValidations.confirmPassword"
                     v-model="model.confirmPassword"
                     :error="getError('confirmPassword')">
          </fg-input>
        </div>
      </div>
      <div class="card-footer text-center">
        <p-button type="info" @click.prevent="validate">Update</p-button>
      </div>
    </form>

  </div>
</template>
<script>
  export default {
    data () {
      return {
        model: {
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        },
        modelValidations: {
          oldPassword: {
            required: true,
            min: 5
          },
          newPassword: {
            required: true,
            min: 5
          },
          confirmPassword: {
            required: true,
            confirmed: 'newPassword'
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid)
        })
      }
    }
  }
</script>
<style>
</style>
